<a class="download-zip-link" #downloadReportesLink aria-label="Descargar reporte"></a>

<div class="main-content table-page table-page--compact riesgos-page" *ngIf="mostrarPrincipal">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Consulta de Riesgos</h1>
        <p>Revise los riesgos registrados en su área y dé seguimiento a sus acciones.</p>
      </div>

      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="descargarProyecto()">
        <i class="material-icons">download</i>
        <span>Descargar reporte</span>
      </button>
    </section>

    <section class="table-page__card">
      <div class="table-page__toolbar">
        <mat-form-field appearance="outline" class="table-page__search-field">
          <mat-label>Buscar riesgo</mat-label>
          <input matInput aria-label="Buscar riesgo" type="search" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" autocomplete="off" />
          <button *ngIf="searchTerm" matSuffix mat-icon-button type="button" aria-label="Limpiar búsqueda" (click)="searchTerm = ''; onSearchChange()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div class="table-page__toolbar-actions">
          <span class="table-page__subtext">{{ totalRiesgos }} riesgo(s) registrado(s)</span>
        </div>
      </div>

      <div class="table-page__table-wrap">
        <table class="table-page__table table-page__table--xwide" *ngIf="filteredRiesgos.length > 0; else riesgosEmptyState">
          <thead>
            <tr>
              <th>ID</th>
              <th>Fase</th>
              <th>Descripción</th>
              <th>Causa raíz</th>
              <th>Probabilidad</th>
              <th>Severidad</th>
              <th>Estrategia</th>
              <th>Fecha de identificación</th>
              <th>Periodicidad</th>
              <th>Acciones a seguir</th>
              <th>Responsable</th>
              <th>Último seguimiento</th>
              <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let riesgo of filteredRiesgos">
              <td class="table-page__name">{{ riesgo.id }}</td>
              <td>{{ riesgo.faseDeteccion?.nombre_faseDeteccion || "Sin fase" }}</td>
              <td class="table-page__description">{{ riesgo.descripcion || "Sin descripción" }}</td>
              <td>{{ riesgo.causa_raiz || "Sin causa registrada" }}</td>
              <td>{{ riesgo.probabilidad?.nombre || "Sin probabilidad" }}</td>
              <td>{{ riesgo.severidad?.descripcion || "Sin severidad" }}</td>
              <td>{{ riesgo.estrategia?.estrategia || "Sin estrategia" }}</td>
              <td>{{ formatDate(riesgo.fecha_identificacion) }}</td>
              <td>{{ riesgo.periodicidad?.descripcion || "Sin periodicidad" }}</td>
              <td class="table-page__description">{{ riesgo.acciones_seguir || "Sin acciones registradas" }}</td>
              <td>{{ riesgo.responsable_recurso || "Sin responsable" }}</td>
              <td><span class="table-page__status-badge is-pending">{{ estatusPorRiesgo[riesgo.id] || "Cargando..." }}</span></td>
              <td class="table-page__actions table-page__actions--multi">
                <div class="table-page__action-group">
                  <button type="button" class="table-page__action-btn" matTooltip="Modificar riesgo" aria-label="Modificar riesgo" (click)="openEditar(riesgo.id)">
                    <i class="material-icons">edit</i>
                  </button>
                  <button type="button" class="table-page__action-btn" matTooltip="Agregar seguimiento" aria-label="Agregar seguimiento" (click)="agregarSeguimiento(riesgo)">
                    <i class="material-icons">playlist_add</i>
                  </button>
                  <button type="button" class="table-page__action-btn" matTooltip="Consultar historial de cambios" aria-label="Consultar historial de cambios" (click)="openConsultaHistorial(riesgo)">
                    <i class="material-icons">history</i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #riesgosEmptyState>
          <div class="table-page__empty" *ngIf="!loading; else riesgosLoadingState">
            <i class="material-icons">shield</i>
            <strong>{{ searchTerm ? "No se encontraron riesgos en esta página" : "No se encontraron riesgos" }}</strong>
            <span>{{ searchTerm ? "Pruebe con otro término de búsqueda." : "No hay riesgos registrados para el área seleccionada." }}</span>
          </div>
        </ng-template>

        <ng-template #riesgosLoadingState>
          <div class="table-page__empty table-page__empty--loading">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando riesgos...</strong>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="totalRiesgos > 0">
        <div class="table-page__meta">
          <span>Mostrando {{ getRangeEnd() }} de {{ totalRiesgos }} riesgos</span>
          <label class="table-page__page-size">
            <span>Registros:</span>
            <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">Inicio</button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">Anterior</button>
          <ng-container *ngFor="let item of getPaginationItems()">
            <button *ngIf="isPageNumber(item); else riesgosPagerEllipsis" type="button" class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
              {{ item }}
            </button>
            <ng-template #riesgosPagerEllipsis><span class="table-page__pager-ellipsis">...</span></ng-template>
          </ng-container>
          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">Siguiente</button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">Último</button>
        </div>
      </div>
    </section>
  </div>
</div>

<app-alta-riesgo-wizard *ngIf="mostrarConsulta" [riesgoSeleccionado]="riesgoSeleccionado" [esEditar]="esEditar"
  (mostrarMascaraConsulta)="mostrarMascaraConsulta($event)" (mostrarPrincipal)="mostrarVistaPrincipal($event)">
</app-alta-riesgo-wizard>
